import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { blue } from '../tokens/colors.js';
import { Button } from './button.js';

const helpers = createMultiStyleConfigHelpers([
  "trigger",
  "cell",
  "clearTrigger",
  "content",
  "contentHeader",
  "row",
  "headerCell",
  "navIcon",
  "navButton"
]);
const beforeElementStyles = {
  content: '""',
  position: "absolute",
  height: "calc(100% + 4px)",
  background: "var(--cell-bg-color)",
  top: "-2px",
  width: ".25rem",
  left: "-.25rem",
  border: "none"
};
const DatePicker = helpers.defineMultiStyleConfig({
  baseStyle: {
    row: {
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)",
      width: "100%"
    },
    headerCell: {
      fontWeight: "bold",
      textAlign: "center",
      paddingBottom: ".5rem"
    },
    trigger: {
      width: "max-content",
      backgroundColor: "transparent",
      borderRadius: "xs",
      padding: "0",
      _focusVisible: {
        outlineColor: "text-primary",
        outlineOffset: "2px"
      }
    },
    cell: {
      "--cell-bg-color": "transparent",
      bgColor: "var(--cell-bg-color)",
      borderRadius: "50%",
      border: "2px solid transparent",
      position: "relative",
      rowGap: "1rem",
      cursor: "default",
      fontSize: "text-sm",
      fontWeight: "500",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      _focusVisible: {
        outline: "none"
      },
      _disabled: {
        color: "text-secondary",
        _hover: {
          bgColor: "darkBlueAlpha.200"
        }
      },
      "&[data-focused]": {
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: "blue.500",
        outlineColor: "black"
      },
      "&[data-selected]": {
        color: "gray.50",
        "--cell-bg-color": blue["500"]
      },
      "&[data-in-range]": {
        color: "gray.50",
        "--cell-bg-color": blue["500"]
      },
      "&[data-range-start]": {
        borderRadius: "50% 0 0 50%"
      },
      "&[data-range-end]": {
        borderRadius: "0 50% 50% 0",
        _before: beforeElementStyles
      },
      "&[data-in-range]:not([data-range-start]):not([data-range-end])": {
        borderRadius: "0",
        _before: beforeElementStyles
      },
      _hover: {
        color: "white",
        "--cell-bg-color": blue["500"]
      },
      _dark: {
        "&[data-focused]": {
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor: "blue.500",
          outlineColor: "white"
        },
        '&[data-selected], &[aria-selected="true"]': {
          color: "white",
          "--cell-bg-color": blue["500"]
        }
      }
    },
    content: {
      minWidth: "300px",
      borderRadius: "sm",
      padding: "2rem",
      border: "1px solid",
      borderColor: "stroke",
      bgColor: "surface",
      boxShadow: "md",
      position: "relative"
    },
    contentHeader: {
      fontSize: "heading-sm",
      fontWeight: "bold",
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      paddingBottom: "1rem",
      alignItems: "center"
    },
    navButton: {
      ...Button.variants?.tertiary,
      padding: "xs",
      borderRadius: "50%",
      mx: "calc( var(--vimeo-space-xs) / 2)",
      svg: {
        height: "xs",
        width: "xs"
      },
      _focusVisible: {
        outlineColor: "text-primary"
      }
    },
    navIcon: {
      borderRadius: "50%",
      _focusVisible: {
        outlineColor: "text-primary"
      }
    }
  }
});

export { DatePicker };
